// i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enHeader from "./locales/en/header.json";
import enHome from "./locales/en/home.json";
import svHeader from "./locales/sv/header.json";
import svHome from "./locales/sv/home.json";
import daHeader from "./locales/da/header.json";
import daHome from "./locales/da/home.json";
import daItsupport from "./locales/da/itsupport.json";
import enItsupport from "./locales/en/itsupport.json";
import svItSupport from "./locales/sv/itsupport.json";
import daSwService from "./locales/da/swservices.json";
import enSwService from "./locales/en/swservices.json";
import svSwService from "./locales/sv/swservices.json";
import daDataEngineering from "./locales/da/dataengineering.json";
import enDataEngineering from "./locales/en/dataengineering.json";
import svDataEngineering from "./locales/sv/dataengineering.json";
import daContact from "./locales/da/contact.json";
import enContact from "./locales/en/contact.json";
import svContact from "./locales/sv/contact.json";
import daAbout from "./locales/da/about.json";
import enAbout from "./locales/en/about.json";
import svAbout from "./locales/sv/about.json";

// Workflow imports - English
import enWorkflowHeader from "./locales/en/workflow.json";
import enWorkflowHome from "./locales/en/workflowHome.json";
import enWorkflowServices from "./locales/en/workflowServices.json";
import enWorkflowBooking from "./locales/en/workflowBooking.json";
import enWorkflowAbout from "./locales/en/workflowAbout.json";
import enWorkflowContact from "./locales/en/workflowContact.json";

// Workflow imports - Swedish
import svWorkflowHeader from "./locales/sv/workflow.json";
import svWorkflowHome from "./locales/sv/workflowHome.json";
import svWorkflowServices from "./locales/sv/workflowServices.json";
import svWorkflowBooking from "./locales/sv/workflowBooking.json";
import svWorkflowAbout from "./locales/sv/workflowAbout.json";
import svWorkflowContact from "./locales/sv/workflowContact.json";

// Workflow imports - Danish
import daWorkflowHeader from "./locales/da/workflow.json";
import daWorkflowHome from "./locales/da/workflowHome.json";
import daWorkflowServices from "./locales/da/workflowServices.json";
import daWorkflowBooking from "./locales/da/workflowBooking.json";
import daWorkflowAbout from "./locales/da/workflowAbout.json";
import daWorkflowContact from "./locales/da/workflowContact.json";

const isWorkflowSite = window.location.hostname.includes('workflow') ||
    window.location.pathname.includes('/workflow');

i18n.use(initReactI18next).init({
    resources: {
        da: {
            header: daHeader,
            home: daHome,
            itsupport: daItsupport,
            swservice: daSwService,
            dataengineering: daDataEngineering,
            contact: daContact,
            about: daAbout,

            // Workflow 
            workflowheader: daWorkflowHeader,
            workflowhome: daWorkflowHome,
            workflowservices: daWorkflowServices,
            workflowbooking: daWorkflowBooking,
            workflowabout: daWorkflowAbout,
            workflowcontact: daWorkflowContact,
        },
        en: {
            header: enHeader,
            home: enHome,
            itsupport: enItsupport,
            swservice: enSwService,
            dataengineering: enDataEngineering,
            contact: enContact,
            about: enAbout,

            workflowheader: enWorkflowHeader,
            workflowhome: enWorkflowHome,
            workflowservices: enWorkflowServices,
            workflowbooking: enWorkflowBooking,
            workflowabout: enWorkflowAbout,
            workflowcontact: enWorkflowContact,
        },
        sv: {
            header: svHeader,
            home: svHome,
            itsupport: svItSupport,
            swservice: svSwService,
            dataengineering: svDataEngineering,
            contact: svContact,
            about: svAbout,

            workflowheader: svWorkflowHeader,
            workflowhome: svWorkflowHome,
            workflowservices: svWorkflowServices,
            workflowbooking: svWorkflowBooking,
            workflowabout: svWorkflowAbout,
            workflowcontact: svWorkflowContact,
        },
    },
    ns: ["header", "home", "itsupport", "swservice", "dataengineering", "contact", "about",

        "workflowheader", "workflowhome", "workflowservices", "workflowbooking", "workflowabout", "workflowcontact"
    ], // Declare all namespaces
    defaultNS: "header",
    lng: isWorkflowSite ? "da" : "en",
    fallbackLng: isWorkflowSite ? "da" : "en",
    interpolation: { escapeValue: false },
    detection: {
        // added browser language detection too
        order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        caches: ['localStorage', 'cookie'],
    }
});